const urlApi = () =>
  process.env.REACT_APP_BACKEND_URL || "http://localhost:5000/";

export default urlApi;
